import { FunctionComponent } from 'react';

import { TypeListStepByStepProps } from './types';

/**
 * ListStepByStep
 */
export const ListStepByStep: FunctionComponent<TypeListStepByStepProps> = ({
  className = '',
  title,
  text,
}: TypeListStepByStepProps) => (
  <div className={`flex ${className}`}>
    <div className="w-10 text-headline text-headline--h2 text-text-tertiary whitespace-nowrap">
      {title}
    </div>
    <div className="ml-4 text-body text-body--l text-text-primary">{text}</div>
  </div>
);

ListStepByStep.displayName = 'ListStepByStep';
